import React from 'react'
import { useTranslation } from 'react-i18next'

import { useProductReadContext } from '@context/ProductContext'

import { Body1, Heading3 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { Box } from '@shared/components/Box'

import styles from './CompletionBlock.module.scss'

interface Props {
  onButtonClick: () => void
}
export const CompletionBlock: React.FC<Props> = (props) => {
  const { onButtonClick } = props
  const { isDefaultCFDProductType } = useProductReadContext()

  const isCFDProduct = isDefaultCFDProductType()

  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <Heading3 className={styles.title}>{t('Congratulations') + '!'}</Heading3>
      <Body1 isParagraph className={styles.paragraph}>
        {isCFDProduct
          ? t('Your details are successfully updated')
          : t('You have successfully passed the test')}
      </Body1>
      <Body1 isParagraph className={styles.paragraph}>
        {isCFDProduct
          ? t('You have now completed registration for the CFD product')
          : t('You have now completed the registration for your Futures account!')}
      </Body1>
      <Box mt='x16' px='x56'>
        <Button.Primary
          iconRight={{ icon: ArrowIcon.Right, color: 'text-white' }}
          size='lg'
          type='button'
          onClick={onButtonClick}
        >
          {t('Go To Dashboard')}
        </Button.Primary>
      </Box>
    </div>
  )
}
